module.exports = __webpack_public_path__ + "fba2d1cdb660cd2d13b05fe985973d4f.png";